const subscriptions = {
    base: {
        id: 21,
        name: "Abbonamento Base",
        short: "Base",
        description: "Pacchetto preventivi",
        price: 117.12,
        trial: false,
    },
    dynamic: {
        id: 23,
        name: "Abbonamento Dinamico",
        short: "Dinamico",
        description: "Pacchetto preventivi + Consuntivi",
        price: 152.50,
        trial: false,
    },
    trial_base: {
        id: 20,
        name: "Prova 15 giorni - BASE",
        short: "Dinamico",
        description: "Pacchetto preventivi",
        price: 0,
        trial: true,
    },
    trial_dynamic: {
        id: 22,
        name: "Prova 15 giorni - DINAMICO",
        short: "Dinamico",
        description: "Pacchetto preventivi + Consuntivi",
        price: 0,
        trial: true,
    }
};

export default subscriptions;